
import * as React from "react";
import { cn } from "@/lib/utils";
import { ButtonProps, buttonVariants } from "@/components/ui/button";

export interface RSVPButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: "default";
}

const RSVPButton = React.forwardRef<HTMLButtonElement, RSVPButtonProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <button
        className={cn(
          "bg-black text-white font-semibold px-8 py-5 min-h-[72px] min-w-[200px] rounded-full text-lg shadow-lg hover:shadow-xl transition-all active:scale-95 active:shadow-md disabled:bg-[#7F7F7F] disabled:opacity-100 disabled:active:scale-100",
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  }
);

RSVPButton.displayName = "RSVPButton";

export { RSVPButton };
